// extracted by mini-css-extract-plugin
export default {"classes":"ShareUs_classes__IhRo7","fa-facebook":"ShareUs_fa-facebook__GRDLd","fa-twitter":"ShareUs_fa-twitter__bdjW4","fa-whatsapp":"ShareUs_fa-whatsapp__CYk4T"};